import { EditActions } from "../../common/form/FormActions";
import { EldMultipleForm } from "./EldMultipleForm";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";
import { HookFormCreateView } from "../../common/form/hook-form/HookFormCreateView";
import { MasterEldDeviceApiFactory } from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { useHistory } from "react-router-dom";

interface IEldMultipleCreateProps {}

export const EldMultipleCreate = (props: IEldMultipleCreateProps) => {
  const fieldPermissions = useFieldPermissions(
    protectedEntities.MasterEldDevice,
    (x) => x.create
  );
  const history = useHistory();

  const axios = useAxiosInstance();

  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <HookFormCreateView
        {...props}
        actions={<EditActions />}
        title="Create Multiple ELDs"
        onSuccess={() => {
          history.push("/master-elds");
        }}
        variant="outlined"
        margin="dense"
        className="form-create-edit-drawer"
        createMethodOverride={(data) => {
          if (!axios) {
            return Promise.reject("Axios was undefined");
          }

          return MasterEldDeviceApiFactory(
            undefined,
            axios.defaults.baseURL,
            axios
          ).apiAppMasterelddeviceMultipleelddevicesPost(data);
        }}
      >
        <EldMultipleForm />
      </HookFormCreateView>
    </FieldPermissionsContext.Provider>
  );
};
